export function scrollTop(behavior: ScrollBehavior = "auto") {
  window.scrollTo({ left: 0, top: 0, behavior });
}
